var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldMediumTrust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    viewBox: "0 0 29 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8846 6.88564C21.7108 6.88564 15.3127 1.1629 15.2493 1.10557C14.8241 0.720018 14.1759 0.720018 13.7507 1.10557C13.687 1.16335 7.30562 6.88564 1.11538 6.88564C0.499395 6.88564 0 7.38504 0 8.00103V21.6114C0 32.4324 8.04832 36.7564 14.1022 39.0675C14.2303 39.1164 14.3651 39.1408 14.5 39.1408C14.6349 39.1408 14.7697 39.1164 14.8978 39.0675C23.3862 35.827 29 30.7721 29 21.6114V8.00103C29 7.38504 28.5006 6.88564 27.8846 6.88564Z",
    fill: "url(#paint0_linear_413_11625ss)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_11625ss",
    x1: 14.5,
    y1: 39.1226,
    x2: 14.5,
    y2: 1.05078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#FCCE57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC48D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldMediumTrust);
export default __webpack_public_path__ + "static/media/ShieldMediumTrust.ce21a3df9c2064749402a410bf2c084a.svg";
export { ForwardRef as ReactComponent };